import { NavLink, useLocation } from 'react-router-dom';
import { Home, MapPin, ClipboardCheck, Clock, Package, Receipt } from 'lucide-react';

const navItems = [
  { path: '/dashboard', icon: Home, label: 'Accueil' },
  { path: '/route', icon: MapPin, label: 'Trajets' },
  { path: '/orders', icon: Package, label: 'Commandes' },
  { path: '/expenses', icon: Receipt, label: 'Depenses' },
  { path: '/hours', icon: Clock, label: 'Heures' },
];

export const BottomNav = ({ unreadCount = 0, newDispatchCount = 0 }) => {
  const location = useLocation();

  return (
    <nav className="bottom-nav" data-testid="bottom-navigation">
      {navItems.map(({ path, icon: Icon, label }) => {
        const isActive = location.pathname === path || location.pathname.startsWith(path + '/');
        const showDispatchBadge = path === '/orders' && newDispatchCount > 0;

        return (
          <NavLink
            key={path}
            to={path}
            className={`nav-item ${isActive ? 'active' : ''}`}
            data-testid={`nav-${path.slice(1)}`}
          >
            <div className="relative">
              <Icon size={28} strokeWidth={2} />
              {showDispatchBadge && (
                <span
                  className="absolute -top-1.5 -right-2.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[22px] h-[22px] flex items-center justify-center px-1 animate-dispatch-badge"
                  data-testid="dispatch-badge"
                >
                  {newDispatchCount > 9 ? '9+' : newDispatchCount}
                </span>
              )}
            </div>
            <span className="nav-label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNav;
